import React from 'react';
import styles from './styles.scss';
import { useTranslation } from 'react-i18next';

export const ViewType = ({ viewType }) => {
  const { t } = useTranslation();

  if (!viewType) {
    return null;
  }

  return <span className={styles.Container}>{viewType !== 'panoramicView' ? 'ВИД ' : ''}{t(`constants.view_type.${viewType}`)}</span>;
};



// WEBPACK FOOTER //
// ./src/components/FlatsList/FlatsListItem/ViewType/index.js